import * as Yup from "yup";

export const loginValidation = Yup.object().shape({
  email: Yup.string().required("Email is Required"),
  password: Yup.string().required("Password is Required"),
});

export const addAccountSchemaValidation = Yup.object().shape({
  name: Yup.string().required("Account Name is Required"),
  parentId: Yup.string().label("ParentId"),
  // accountType: Yup.string().required("Account Type is Required"),
  // accountType: Yup.string().when("parentId", {
  //   is: "",
  //   then: Yup.string().required("Account Type is Required"),
  //   otherwise: Yup.string(),
  // }),
  // currency: Yup.string().required("Currency Type is Required"),
  code: Yup.string().required("Account Number is Required"),
});
